module.exports = __webpack_public_path__ + "static/media/antenna_config.b1f78f25.svg";